import React from 'react';
import {Container, WrapperButtons} from './styles';
import {Button} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {Loading} from 'presentation/components/Loading/Loading';
import type {FooterCardSessionProps} from './types';

const {cancel, saveChanges} = translations['pt-br'].commons;

const {duplicate: duplicateLabel, edit: editLabel} =
	translations['pt-br'].privateFlow.refund.therapies;

export const FooterCardSession = ({
	isEdit,
	isLoading,
	onCancel,
	onDuplicate,
	onEdit,
	onSave,
}: FooterCardSessionProps) => {
	return (
		<Container>
			{isEdit ? (
				<WrapperButtons>
					<Button
						size="small"
						disabled={isLoading}
						variant="text"
						color="error"
						onClick={onCancel}>
						{cancel}
					</Button>
					<Button
						size="small"
						disabled={isLoading}
						variant="text"
						color="primary"
						onClick={onSave}
						endIcon={isLoading && <Loading size={16} color="inherit" />}>
						{saveChanges}
					</Button>
				</WrapperButtons>
			) : (
				<WrapperButtons>
					<Button
						size="small"
						disabled={isLoading}
						variant="text"
						color="primary"
						onClick={onDuplicate}>
						{duplicateLabel}
					</Button>
					<Button
						size="small"
						disabled={isLoading}
						variant="text"
						color="primary"
						onClick={onEdit}>
						{editLabel}
					</Button>
				</WrapperButtons>
			)}
		</Container>
	);
};
